<dx-chart [dataSource]="chartData"
          (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
    <dxo-chart-animation [enabled]="false"></dxo-chart-animation>
    <dxi-chart-series type="bar"
                      axis="ResponseCount"
                      valueField="count"
                      argumentField="label"
                      name="Response Distribution"> </dxi-chart-series>
    <dxi-chart-value-axis name="ResponseCount"
                          [allowDecimals]="false"
                          [valueMarginsEnabled]="false"
                          [showZero]="true"
                          [visualRange]="[0, maxResponseCount]"
                          visualRangeUpdateMode="keep">
        <dxo-chart-title text="Response count"></dxo-chart-title>
    </dxi-chart-value-axis>
    <dxo-chart-argument-axis>
        <dxo-chart-title text="Response distribution"></dxo-chart-title>
        <dxo-chart-label overlappingBehavior="stagger"></dxo-chart-label>
    </dxo-chart-argument-axis>
    <dxo-chart-tooltip [enabled]="true"
                       [customizeTooltip]="customiseChartTooltip"></dxo-chart-tooltip>
    <dxo-chart-legend [visible]="false"></dxo-chart-legend>
</dx-chart>
